<template>
    <div id="masthead">
      <v-img src='@/assets/site-images/fantasy-art-masthead.jpg' />
    </div>
</template>

<script>
export default {
  name: 'Masthead.vue'
}
</script>

<style scoped>

</style>
